































/** @format */

import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { PLATE_PROVINCE_STRING, PLATE_PROVINCE_AFTER } from './constant';

@Component
export default class PlateInput extends Vue {
  PlateProvinceString = PLATE_PROVINCE_STRING.split('');
  /**
   * 是否可清空
   */
  @Prop({ default: false })
  value: boolean = false;
  /**
   * 是否需要传入其他值 会变成 plateChange 第二个值传出
   * 可为空
   */
  @Prop({ default: () => {} })
  params!: object;
  /**
   * 车牌号默认值
   */
  @Prop({ default: '' })
  defaultPlate!: string;

  plateHead: string = '';
  plateTail: string = '';

  created() {
    if (this.defaultPlate !== '') {
      this.validationPlate(this.defaultPlate);
    }
  }

  get isEmty() {
    return this.value;
  }

  set isEmty(val: boolean) {
    this.$emit('input', false);
  }

  private plateHeadChange(value: any) {
    if (value) {
      this.isEmty = false;
    }
    this.plateHead = value ? value.toLocaleUpperCase() : '';
    this.$emit('plateChange', [value ? value.toLocaleUpperCase() : '', this.plateTail || ''], this.params);
  }

  private plateTailChange({ target: { value } }: any) {
    if (value) {
      this.isEmty = false;
    }
    this.validationPlate(value);
  }

  validationPlate(value: any) {
    let plate: any = Array.from(value.trim().toLocaleUpperCase());
    const plateHead = '' + plate.splice(0, 1);
    let plateAfter = '' + plate.splice(plate.length - 1, 1);
    if (this.PlateProvinceString.includes(plateHead)) {
      this.plateHead = plateHead.toLocaleUpperCase();
      this.plateTail = '' + plate;
    } else {
      this.plateTail = plateHead + plate;
    }
    if (!PLATE_PROVINCE_AFTER.includes(plateAfter)) {
      plateAfter = plateAfter.replace(/[^\\u0000-\\u00FF]/g, '');
    }

    this.plateTail = this.plateTail.replace(/[^\\u0000-\\u00FF]/g, '');
    this.plateTail = this.plateTail + plateAfter;
    this.plateTail = this.plateTail.replace(/O/g, ''); //不包含OI 车牌
    this.plateTail = this.plateTail.replace(/I/g, ''); //不包含OI 车牌
    this.plateTail = this.plateTail.replace(/^%&',;=?$\x22+/g, ''); //不包含OI 车牌/([\*\"\'<>\/])+/
    // this.plateTail = this.plateTail.replace(/([\\*\\"\\'<>\\/])+/g, '') //不包含OI 车牌[ ,//`,//~,//!,//@,/#,//$,//%,//^,//+,//*,//&,,///,//?,//|,//:,//.,//<,//>,//{,//},//(,//),//',//;,//=,/"]
    this.plateTail = this.plateTail.replace(
      /[ ,//`,//~,//!,//@,/#,//$,//%,//^,//+,//*,//&,,///,//?,//|,//:,//.,//<,//>,//{,//},//(,//),//',//;,//[//=,/"]/g,
      ''
    ); //不包含OI 车牌
    this.$emit('plateChange', [this.plateHead.toLocaleUpperCase() || '', this.plateTail || ''], this.params);
  }

  @Watch('defaultPlate')
  onDefaultValueChange(newVal: any, oldVal: any) {
    console.log('defaultPlate changed--:', newVal);
    this.plateHead = newVal.charAt(0).toLocaleUpperCase();
    this.plateTail = newVal.slice(1);
  }

  @Watch('isEmty')
  onChangeValue(newVal: any, oldVal: any) {
    if (newVal === true) {
      this.plateHead = '';
      this.plateTail = '';
    }
  }
}
